export default <const>[
  {
    id: 'f_buruburuFood_b',
    item: 'buruburuFood',
    name_jp: '震える\nブルブルフード',
    name_en: 'Vibrating Buruburu Food',
    type: 'food',
    priority: 100,
    stages: 'baby',
    price: 40,
    desc_jp: '食べるとなんだかぶるぶる\nしちゃう不思議な食べもの',
    desc_en: 'Mysterious food that vibrates you',
    stomach: 40,
    tooth_acidity: 5,
  },
  {
    id: 'f_gentleSushi_b',
    item: 'gentleSushi',
    name_jp: 'やさしいおすし',
    name_en: 'Gentle Sushi',
    type: 'food',
    priority: 90,
    stages: 'baby',
    price: 60,
    desc_jp: 'ガンコなすし職人がにぎった\nやさしい味のおすし',
    desc_en: 'Gentle taste sushi made by a stubborn sushi chef',
    stomach: 60,
    tooth_acidity: 5,
  },
  {
    id: 'f_buruburuFood_k',
    item: 'buruburuFood',
    name_jp: '震える\nブルブルフード',
    name_en: 'Vibrating Buruburu Food',
    type: 'food',
    priority: 100,
    stages: 'kid',
    price: 40,
    desc_jp: '食べるとなんだかぶるぶる\nしちゃう不思議な食べもの',
    desc_en: 'Mysterious food that vibrates you',
    stomach: 20,
    tooth_acidity: 5,
  },
  {
    id: 'f_gentleSushi_k',
    item: 'gentleSushi',
    name_jp: 'やさしいおすし',
    name_en: 'Gentle Sushi',
    type: 'food',
    priority: 90,
    stages: 'kid',
    price: 60,
    desc_jp: 'ガンコなすし職人がにぎった\nやさしい味のおすし',
    desc_en: 'Gentle taste sushi made by a stubborn sushi chef',
    stomach: 30,
    tooth_acidity: 5,
  },
  {
    id: 'f_attractiveCurryAndRice_k',
    item: 'attractiveCurryAndRice',
    name_jp: '魅惑のカレー',
    name_en: 'Attractive Curry and Rice',
    type: 'food',
    priority: 80,
    stages: 'kid',
    price: 80,
    desc_jp: '辛いのについつい何度も\n食べてしまう不思議なカレー',
    desc_en: "Very spicy curry and rice you can't stop eating",
    stomach: 40,
    tooth_acidity: 5,
  },
  {
    id: 'f_skewedSalad_k',
    item: 'skewedSalad',
    name_jp: 'かたよった\nサラダ',
    name_en: 'Skewed Salad',
    type: 'food',
    priority: 70,
    stages: 'kid',
    price: 120,
    desc_jp: 'バランス良いかと思ったら\n意外とかたよってるサラダ',
    desc_en: 'Not very well-balanced salad',
    stomach: 60,
    tooth_acidity: 5,
  },
  {
    id: 'f_buruburuFood_y',
    item: 'buruburuFood',
    name_jp: '震える\nブルブルフード',
    name_en: 'Vibrating Buruburu Food',
    type: 'food',
    priority: 100,
    stages: 'youth',
    price: 40,
    desc_jp: '食べるとなんだかぶるぶる\nしちゃう不思議な食べもの',
    desc_en: 'Mysterious food that vibrates you',
    stomach: 10,
    tooth_acidity: 5,
  },
  {
    id: 'f_gentleSushi_y',
    item: 'gentleSushi',
    name_jp: 'やさしいおすし',
    name_en: 'Gentle Sushi',
    type: 'food',
    priority: 90,
    stages: 'youth',
    price: 60,
    desc_jp: 'ガンコなすし職人がにぎった\nやさしい味のおすし',
    desc_en: 'Gentle taste sushi made by a stubborn sushi chef',
    stomach: 15,
    tooth_acidity: 5,
  },
  {
    id: 'f_attractiveCurryAndRice_y',
    item: 'attractiveCurryAndRice',
    name_jp: '魅惑のカレー',
    name_en: 'Attractive Curry and Rice',
    type: 'food',
    priority: 80,
    stages: 'youth',
    price: 80,
    desc_jp: '辛いのについつい何度も\n食べてしまう不思議なカレー',
    desc_en: "Very spicy curry and rice you can't stop eating",
    stomach: 20,
    tooth_acidity: 5,
  },
  {
    id: 'f_skewedSalad_y',
    item: 'skewedSalad',
    name_jp: 'かたよった\nサラダ',
    name_en: 'Skewed Salad',
    type: 'food',
    priority: 70,
    stages: 'youth',
    price: 120,
    desc_jp: 'バランス良いかと思ったら\n意外とかたよってるサラダ',
    desc_en: 'Not very well-balanced salad',
    stomach: 30,
    tooth_acidity: 5,
  },
  {
    id: 'f_tooSpicyTteokbokki_y',
    item: 'tooSpicyTteokbokki',
    name_jp: '激辛すぎる\nトッポギ',
    name_en: 'Too Spicy Tteokbokki',
    type: 'food',
    priority: 60,
    stages: 'youth',
    price: 160,
    desc_jp: '辛いのにもほどがある、\nでもおいしいトッポギ',
    desc_en: 'Very spicy, but very tasty Tteokbokki',
    stomach: 40,
    tooth_acidity: 5,
  },
  {
    id: 'f_meatLessBurger_y',
    item: 'meatLessBurger',
    name_jp: 'ミート0%\nハンバーガー',
    name_en: 'Meat Less Burger',
    type: 'food',
    priority: 50,
    stages: 'youth',
    price: 240,
    desc_jp: 'お肉を一切使っていないのに\n肉の味がするバーガー',
    desc_en: 'Burger that tastes meat but not using any meat',
    stomach: 60,
    tooth_acidity: 5,
  },
  {
    id: 'f_buruburuFood_a',
    item: 'buruburuFood',
    name_jp: '震える\nブルブルフード',
    name_en: 'Vibrating Buruburu Food',
    type: 'food',
    priority: 100,
    stages: 'adult',
    price: 40,
    desc_jp: '食べるとなんだかぶるぶる\nしちゃう不思議な食べもの',
    desc_en: 'Mysterious food that vibrates you',
    stomach: 5,
    tooth_acidity: 5,
  },
  {
    id: 'f_gentleSushi_a',
    item: 'gentleSushi',
    name_jp: 'やさしいおすし',
    name_en: 'Gentle Sushi',
    type: 'food',
    priority: 90,
    stages: 'adult',
    price: 60,
    desc_jp: 'ガンコなすし職人がにぎった\nやさしい味のおすし',
    desc_en: 'Gentle taste sushi made by a stubborn sushi chef',
    stomach: 8,
    tooth_acidity: 5,
  },
  {
    id: 'f_attractiveCurryAndRice_a',
    item: 'attractiveCurryAndRice',
    name_jp: '魅惑のカレー',
    name_en: 'Attractive Curry and Rice',
    type: 'food',
    priority: 80,
    stages: 'adult',
    price: 80,
    desc_jp: '辛いのについつい何度も\n食べてしまう不思議なカレー',
    desc_en: "Very spicy curry and rice you can't stop eating",
    stomach: 10,
    tooth_acidity: 5,
  },
  {
    id: 'f_skewedSalad_a',
    item: 'skewedSalad',
    name_jp: 'かたよった\nサラダ',
    name_en: 'Skewed Salad',
    type: 'food',
    priority: 70,
    stages: 'adult',
    price: 120,
    desc_jp: 'バランス良いかと思ったら\n意外とかたよってるサラダ',
    desc_en: 'Not very well-balanced salad',
    stomach: 15,
    tooth_acidity: 5,
  },
  {
    id: 'f_tooSpicyTteokbokki_a',
    item: 'tooSpicyTteokbokki',
    name_jp: '激辛すぎる\nトッポギ',
    name_en: 'Too Spicy Tteokbokki',
    type: 'food',
    priority: 60,
    stages: 'adult',
    price: 160,
    desc_jp: '辛いのにもほどがある、\nでもおいしいトッポギ',
    desc_en: 'Very spicy, but very tasty Tteokbokki',
    stomach: 20,
    tooth_acidity: 5,
  },
  {
    id: 'f_meatLessBurger_a',
    item: 'meatLessBurger',
    name_jp: 'ミート0%\nハンバーガー',
    name_en: 'Meat Less Burger',
    type: 'food',
    priority: 50,
    stages: 'adult',
    price: 240,
    desc_jp: 'お肉を一切使っていないのに\n肉の味がするバーガー',
    desc_en: 'Burger that tastes meat but not using any meat',
    stomach: 30,
    tooth_acidity: 5,
  },
  {
    id: 'f_dimsumTower_a',
    item: 'dimsumTower',
    name_jp: '点心タワー',
    name_en: 'Dimsum Tower',
    type: 'food',
    priority: 40,
    stages: 'adult',
    price: 320,
    desc_jp: 'ホカホカの点心を\n限界まで積み上げてみました！',
    desc_en: 'Hot dimsums piled up to the limit!',
    stomach: 40,
    tooth_acidity: 5,
  },
  {
    id: 'f_edibleIsland_a',
    item: 'edibleIsland',
    name_jp: '食べられる\n南の島',
    name_en: 'Edible Island',
    type: 'food',
    priority: 30,
    stages: 'adult',
    price: 480,
    desc_jp: 'ぜーんぶ食べられちゃう！\nこれなら誰でも満腹に！',
    desc_en: 'Everything is edible! Gets everyone full!',
    stomach: 60,
    tooth_acidity: 5,
  },
  {
    id: 's_candiesFromPocket_b',
    item: 'candiesFromPocket',
    name_jp: 'ポケットから\nあめちゃん',
    name_en: 'Candies from Pocket',
    type: 'snack',
    priority: 100,
    stages: 'baby',
    price: 40,
    desc_jp: 'なぜかおばちゃんのポッケ\nからいつも出てくるアレ',
    desc_en: "Candies that came out of mom's pocket",
    stomach: 20,
    love: 40,
    tooth_acidity: 30,
  },
  {
    id: 's_rainbowCottonCandy_b',
    item: 'rainbowCottonCandy',
    name_jp: 'レインボー\n綿菓子',
    name_en: 'Rainbow Cotton Candy',
    type: 'snack',
    priority: 90,
    stages: 'baby',
    price: 60,
    desc_jp: '甘くてふわふわで\nシュワシュワの綿菓子',
    desc_en: 'Sweet and fluffy cotton candy',
    stomach: 30,
    love: 60,
    tooth_acidity: 30,
  },
  {
    id: 's_candiesFromPocket_k',
    item: 'candiesFromPocket',
    name_jp: 'ポケットから\nあめちゃん',
    name_en: 'Candies from Pocket',
    type: 'snack',
    priority: 100,
    stages: 'kid',
    price: 40,
    desc_jp: 'なぜかおばちゃんのポッケ\nからいつも出てくるアレ',
    desc_en: "Candies that came out of mom's pocket",
    stomach: 10,
    love: 20,
    tooth_acidity: 30,
  },
  {
    id: 's_rainbowCottonCandy_k',
    item: 'rainbowCottonCandy',
    name_jp: 'レインボー\n綿菓子',
    name_en: 'Rainbow Cotton Candy',
    type: 'snack',
    priority: 90,
    stages: 'kid',
    price: 60,
    desc_jp: '甘くてふわふわで\nシュワシュワの綿菓子',
    desc_en: 'Sweet and fluffy cotton candy',
    stomach: 15,
    love: 30,
    tooth_acidity: 30,
  },
  {
    id: 's_dreamingBerryParfait_k',
    item: 'dreamingBerryParfait',
    name_jp: '夢見る\nベリースイーツ',
    name_en: 'Dreaming Berry Parfait',
    type: 'snack',
    priority: 80,
    stages: 'kid',
    price: 80,
    desc_jp: '夢見る乙女の常備食。\nベリーをふんだんに使いました',
    desc_en: 'Parfait with a lot of berries',
    stomach: 20,
    love: 40,
    tooth_acidity: 30,
  },
  {
    id: 's_tooHardRiceCracker_k',
    item: 'tooHardRiceCracker',
    name_jp: 'かたすぎる\nおせんべい',
    name_en: 'Too Hard Rice Cracker',
    type: 'snack',
    priority: 70,
    stages: 'kid',
    price: 120,
    desc_jp: 'すごくかたいけど、\nすごくおいしいおせんべい',
    desc_en: 'Very hard but very tasty rice crackers',
    stomach: 30,
    love: 50,
    tooth_acidity: 15,
  },
  {
    id: 's_candiesFromPocket_y',
    item: 'candiesFromPocket',
    name_jp: 'ポケットから\nあめちゃん',
    name_en: 'Candies from Pocket',
    type: 'snack',
    priority: 100,
    stages: 'youth',
    price: 40,
    desc_jp: 'なぜかおばちゃんのポッケ\nからいつも出てくるアレ',
    desc_en: "Candies that came out of mom's pocket",
    stomach: 5,
    love: 10,
    tooth_acidity: 30,
  },
  {
    id: 's_rainbowCottonCandy_y',
    item: 'rainbowCottonCandy',
    name_jp: 'レインボー\n綿菓子',
    name_en: 'Rainbow Cotton Candy',
    type: 'snack',
    priority: 90,
    stages: 'youth',
    price: 60,
    desc_jp: '甘くてふわふわで\nシュワシュワの綿菓子',
    desc_en: 'Sweet and fluffy cotton candy',
    stomach: 8,
    love: 15,
    tooth_acidity: 30,
  },
  {
    id: 's_dreamingBerryParfait_y',
    item: 'dreamingBerryParfait',
    name_jp: '夢見る\nベリースイーツ',
    name_en: 'Dreaming Berry Parfait',
    type: 'snack',
    priority: 80,
    stages: 'youth',
    price: 80,
    desc_jp: '夢見る乙女の常備食。\nベリーをふんだんに使いました',
    desc_en: 'Parfait with a lot of berries',
    stomach: 10,
    love: 20,
    tooth_acidity: 30,
  },
  {
    id: 's_tooHardRiceCracker_y',
    item: 'tooHardRiceCracker',
    name_jp: 'かたすぎる\nおせんべい',
    name_en: 'Too Hard Rice Cracker',
    type: 'snack',
    priority: 70,
    stages: 'youth',
    price: 120,
    desc_jp: 'すごくかたいけど、\nすごくおいしいおせんべい',
    desc_en: 'Very hard but very tasty rice crackers',
    stomach: 15,
    love: 25,
    tooth_acidity: 15,
  },
  {
    id: 's_expensiveFruits_y',
    item: 'expensiveFruits',
    name_jp: '実は高級な\nフルーツ',
    name_en: 'Expensive Fruits',
    type: 'snack',
    priority: 60,
    stages: 'youth',
    price: 160,
    desc_jp: 'フルーツって高いのは\nすごく高い。でもおいしい',
    desc_en: 'Very expensive but very delicious fruits',
    stomach: 20,
    love: 40,
    tooth_acidity: 30,
  },
  {
    id: 's_wishFulfillingMontBlanc_y',
    item: 'wishFulfillingMontBlanc',
    name_jp: '願いが叶う\nモンブラン',
    name_en: 'Wisl-fulfilling Mont Blanc',
    type: 'snack',
    priority: 50,
    stages: 'youth',
    price: 240,
    desc_jp: '食べると願いが叶うような\n気になるモンブラン',
    desc_en: 'Mont Blanc that makes your dream come true',
    stomach: 30,
    love: 60,
    tooth_acidity: 30,
  },
  {
    id: 's_candiesFromPocket_a',
    item: 'candiesFromPocket',
    name_jp: 'ポケットから\nあめちゃん',
    name_en: 'Candies from Pocket',
    type: 'snack',
    priority: 100,
    stages: 'adult',
    price: 40,
    desc_jp: 'なぜかおばちゃんのポッケ\nからいつも出てくるアレ',
    desc_en: "Candies that came out of mom's pocket",
    stomach: 3,
    love: 5,
    tooth_acidity: 30,
  },
  {
    id: 's_rainbowCottonCandy_a',
    item: 'rainbowCottonCandy',
    name_jp: 'レインボー\n綿菓子',
    name_en: 'Rainbow Cotton Candy',
    type: 'snack',
    priority: 90,
    stages: 'adult',
    price: 60,
    desc_jp: '甘くてふわふわで\nシュワシュワの綿菓子',
    desc_en: 'Sweet and fluffy cotton candy',
    stomach: 4,
    love: 8,
    tooth_acidity: 30,
  },
  {
    id: 's_dreamingBerryParfait_a',
    item: 'dreamingBerryParfait',
    name_jp: '夢見る\nベリースイーツ',
    name_en: 'Dreaming Berry Parfait',
    type: 'snack',
    priority: 80,
    stages: 'adult',
    price: 80,
    desc_jp: '夢見る乙女の常備食。\nベリーをふんだんに使いました',
    desc_en: 'Parfait with a lot of berries',
    stomach: 5,
    love: 10,
    tooth_acidity: 30,
  },
  {
    id: 's_tooHardRiceCracker_a',
    item: 'tooHardRiceCracker',
    name_jp: 'かたすぎる\nおせんべい',
    name_en: 'Too Hard Rice Cracker',
    type: 'snack',
    priority: 70,
    stages: 'adult',
    price: 120,
    desc_jp: 'すごくかたいけど、\nすごくおいしいおせんべい',
    desc_en: 'Very hard but very tasty rice crackers',
    stomach: 8,
    love: 13,
    tooth_acidity: 15,
  },
  {
    id: 's_expensiveFruits_a',
    item: 'expensiveFruits',
    name_jp: '実は高級な\nフルーツ',
    name_en: 'Expensive Fruits',
    type: 'snack',
    priority: 60,
    stages: 'adult',
    price: 160,
    desc_jp: 'フルーツって高いのは\nすごく高い。でもおいしい',
    desc_en: 'Very expensive but very delicious fruits',
    stomach: 10,
    love: 20,
    tooth_acidity: 30,
  },
  {
    id: 's_wishFulfillingMontBlanc_a',
    item: 'wishFulfillingMontBlanc',
    name_jp: '願いが叶う\nモンブラン',
    name_en: 'Wisl-fulfilling Mont Blanc',
    type: 'snack',
    priority: 50,
    stages: 'adult',
    price: 240,
    desc_jp: '食べると願いが叶うような\n気になるモンブラン',
    desc_en: 'Mont Blanc that makes your dream come true',
    stomach: 15,
    love: 30,
    tooth_acidity: 30,
  },
  {
    id: 's_mameDaifuku_a',
    item: 'mameDaifuku',
    name_jp: '豆を入れすぎた\n大人気の豆大福',
    name_en: 'Mame Daifuku',
    type: 'snack',
    priority: 40,
    stages: 'adult',
    price: 320,
    desc_jp: 'お豆が好きすぎたので\n限界を超えて入れてみました',
    desc_en: 'Love beans so much to put them in daifuku too much',
    stomach: 20,
    love: 40,
    tooth_acidity: 30,
  },
  {
    id: 's_bucketPudding_a',
    item: 'bucketPudding',
    name_jp: 'ひっくり返せない\nバケツプリン',
    name_en: 'Bucket Pudding',
    type: 'snack',
    priority: 30,
    stages: 'adult',
    price: 480,
    desc_jp: '夢のバケツプリン。でも、\nひっくり返したらくずれちゃう',
    desc_en: "Dream bucket pudding. But don't turn it over",
    stomach: 30,
    love: 60,
    tooth_acidity: 30,
  },
  {
    id: 't_miracleBall_b',
    item: 'miracleBall',
    name_jp: 'ミラクル\nボール',
    name_en: 'Miracle Ball',
    type: 'toy',
    priority: 100,
    stages: 'baby',
    price: 40,
    desc_jp: 'すごくよく跳ねるボール',
    desc_en: 'Very well bouncing ball',
    love: 40,
  },
  {
    id: 't_commonBell_b',
    item: 'commonBell',
    name_jp: 'ただのチャイム',
    name_en: 'Common Bell',
    type: 'toy',
    priority: 90,
    stages: 'baby',
    price: 60,
    desc_jp: 'どこにでもある普通の\nチャイム',
    desc_en: 'Very common bell without any characteristics',
    love: 60,
  },
  {
    id: 't_miracleBall_k',
    item: 'miracleBall',
    name_jp: 'ミラクル\nボール',
    name_en: 'Miracle Ball',
    type: 'toy',
    priority: 100,
    stages: 'kid',
    price: 40,
    desc_jp: 'すごくよく跳ねるボール',
    desc_en: 'Very well bouncing ball',
    love: 20,
  },
  {
    id: 't_commonBell_k',
    item: 'commonBell',
    name_jp: 'ただのチャイム',
    name_en: 'Common Bell',
    type: 'toy',
    priority: 90,
    stages: 'kid',
    price: 60,
    desc_jp: 'どこにでもある普通の\nチャイム',
    desc_en: 'Very common bell without any characteristics',
    love: 30,
  },
  {
    id: 't_woollyCaterpillar_k',
    item: 'woollyCaterpillar',
    name_jp: '毛糸の\nいもむしくん',
    name_en: 'Woolly Caterpillar',
    type: 'toy',
    priority: 80,
    stages: 'kid',
    price: 80,
    desc_jp: '毛糸でできたいもむしの\nお人形。すごくかわいい',
    desc_en: 'A caterpillar doll made of yarn. Very cute!',
    love: 40,
  },
  {
    id: 't_noSurpriseJackInTheBox_k',
    item: 'noSurpriseJackInTheBox',
    name_jp: 'とびださない\nびっくりばこ',
    name_en: 'No Surprise Jack in the Box',
    type: 'toy',
    priority: 70,
    stages: 'kid',
    price: 120,
    desc_jp: 'とびださないから誰にも\nびっくりしてもらえない',
    desc_en: 'No one will be surprised...',
    love: 60,
  },
  {
    id: 't_miracleBall_y',
    item: 'miracleBall',
    name_jp: 'ミラクル\nボール',
    name_en: 'Miracle Ball',
    type: 'toy',
    priority: 100,
    stages: 'youth',
    price: 40,
    desc_jp: 'すごくよく跳ねるボール',
    desc_en: 'Very well bouncing ball',
    love: 10,
  },
  {
    id: 't_commonBell_y',
    item: 'commonBell',
    name_jp: 'ただのチャイム',
    name_en: 'Common Bell',
    type: 'toy',
    priority: 90,
    stages: 'youth',
    price: 60,
    desc_jp: 'どこにでもある普通の\nチャイム',
    desc_en: 'Very common bell without any characteristics',
    love: 15,
  },
  {
    id: 't_woollyCaterpillar_y',
    item: 'woollyCaterpillar',
    name_jp: '毛糸の\nいもむしくん',
    name_en: 'Woolly Caterpillar',
    type: 'toy',
    priority: 80,
    stages: 'youth',
    price: 80,
    desc_jp: '毛糸でできたいもむしの\nお人形。すごくかわいい',
    desc_en: 'A caterpillar doll made of yarn. Very cute!',
    love: 20,
  },
  {
    id: 't_noSurpriseJackInTheBox_y',
    item: 'noSurpriseJackInTheBox',
    name_jp: 'とびださない\nびっくりばこ',
    name_en: 'No Surprise Jack in the Box',
    type: 'toy',
    priority: 70,
    stages: 'youth',
    price: 120,
    desc_jp: 'とびださないから誰にも\nびっくりしてもらえない',
    desc_en: 'No one will be surprised...',
    love: 30,
  },
  {
    id: 't_autoPilotAirplane_y',
    item: 'autoPilotAirplane',
    name_jp: '自動運転飛行機',
    name_en: 'Auto Pilot Airplane',
    type: 'toy',
    priority: 60,
    stages: 'youth',
    price: 160,
    desc_jp: 'めったに事故らないけど\nたまに壁にぶつかる飛行機',
    desc_en: 'A plane that rarely crashes',
    love: 40,
  },
  {
    id: 't_fairytaleUnicorn_y',
    item: 'fairytaleUnicorn',
    name_jp: 'メルヘン\nユニコーン',
    name_en: 'Fairytale Unicorn',
    type: 'toy',
    priority: 50,
    stages: 'youth',
    price: 240,
    desc_jp: 'おとぎの国からとびだして\n来たようなユニコーン',
    desc_en: 'A unicorn that just stepped out of a fairy tale',
    love: 60,
  },
  {
    id: 't_miracleBall_a',
    item: 'miracleBall',
    name_jp: 'ミラクル\nボール',
    name_en: 'Miracle Ball',
    type: 'toy',
    priority: 100,
    stages: 'adult',
    price: 40,
    desc_jp: 'すごくよく跳ねるボール',
    desc_en: 'Very well bouncing ball',
    love: 5,
  },
  {
    id: 't_commonBell_a',
    item: 'commonBell',
    name_jp: 'ただのチャイム',
    name_en: 'Common Bell',
    type: 'toy',
    priority: 90,
    stages: 'adult',
    price: 60,
    desc_jp: 'どこにでもある普通の\nチャイム',
    desc_en: 'Very common bell without any characteristics',
    love: 8,
  },
  {
    id: 't_woollyCaterpillar_a',
    item: 'woollyCaterpillar',
    name_jp: '毛糸の\nいもむしくん',
    name_en: 'Woolly Caterpillar',
    type: 'toy',
    priority: 80,
    stages: 'adult',
    price: 80,
    desc_jp: '毛糸でできたいもむしの\nお人形。すごくかわいい',
    desc_en: 'A caterpillar doll made of yarn. Very cute!',
    love: 10,
  },
  {
    id: 't_noSurpriseJackInTheBox_a',
    item: 'noSurpriseJackInTheBox',
    name_jp: 'とびださない\nびっくりばこ',
    name_en: 'No Surprise Jack in the Box',
    type: 'toy',
    priority: 70,
    stages: 'adult',
    price: 120,
    desc_jp: 'とびださないから誰にも\nびっくりしてもらえない',
    desc_en: 'No one will be surprised...',
    love: 15,
  },
  {
    id: 't_autoPilotAirplane_a',
    item: 'autoPilotAirplane',
    name_jp: '自動運転飛行機',
    name_en: 'Auto Pilot Airplane',
    type: 'toy',
    priority: 60,
    stages: 'adult',
    price: 160,
    desc_jp: 'めったに事故らないけど\nたまに壁にぶつかる飛行機',
    desc_en: 'A plane that rarely crashes',
    love: 20,
  },
  {
    id: 't_fairytaleUnicorn_a',
    item: 'fairytaleUnicorn',
    name_jp: 'メルヘン\nユニコーン',
    name_en: 'Fairytale Unicorn',
    type: 'toy',
    priority: 50,
    stages: 'adult',
    price: 240,
    desc_jp: 'おとぎの国からとびだして\n来たようなユニコーン',
    desc_en: 'A unicorn that just stepped out of a fairy tale',
    love: 30,
  },
  {
    id: 't_emptyMagicLamp_a',
    item: 'emptyMagicLamp',
    name_jp: '入居者募集中の\n魔法のランプ',
    name_en: 'Empty Magic Lamp',
    type: 'toy',
    priority: 40,
    stages: 'adult',
    price: 320,
    desc_jp: 'いわくつきの魔法のランプ。\n現在、入居者募集中',
    desc_en:
      'A magic lamp with a story to tell. Currently looking for tenants.',
    love: 40,
  },
  {
    id: 't_doremiPiano_a',
    item: 'doremiPiano',
    name_jp: 'どれみしか\n弾けないピアノ',
    name_en: 'Do-re-mi Piano',
    type: 'toy',
    priority: 30,
    stages: 'adult',
    price: 480,
    desc_jp: '鍵盤がドレミしかないピアノ\n黒鍵はただの飾り',
    desc_en:
      'A piano with only Do Re Mi keys. The black keys are just for decoration.',
    love: 60,
  },
  {
    id: 'fa_whiteTooth',
    item: 'whiteTooth',
    name_jp: '白い歯',
    name_en: 'White Tooth',
    type: 'first_aid',
    priority: 100,
    stages: 'baby, kid, youth, adult',
    price: 300,
    desc_jp: '飲むと虫歯が治るかも\nしれないタブレット',
    desc_en: 'Tablet that might cure cavity when taken',
    tooth_acidity: -50,
    tooth_decay_cure_chance: 0.6,
  },
  {
    id: 'fa_shiningCapsule',
    item: 'shiningCapsule',
    name_jp: '光り輝く歯',
    name_en: 'Shining Tooth',
    type: 'first_aid',
    priority: 90,
    stages: 'baby, kid, youth, adult',
    price: 600,
    desc_jp: '飲むと虫歯が絶対に\n治るタブレット',
    desc_en: 'Tablet that cures cavity for sure when taken',
    tooth_acidity: -100,
    tooth_decay_cure_chance: 1,
  },
  {
    id: 'fa_capsule',
    item: 'capsule',
    name_jp: 'カプセル',
    name_en: 'Capsule',
    type: 'first_aid',
    priority: 80,
    stages: 'baby, kid, youth, adult',
    price: 400,
    desc_jp: '飲むと病気が治るかも\nしれないカプセル',
    desc_en: 'Capsule that might cure diseases when taken',
    stomach: 20,
    love: 20,
    sick_cure_chance: 0.6,
  },
  {
    id: 'fa_superCapsule',
    item: 'superCapsule',
    name_jp: 'スーパー\nカプセル',
    name_en: 'Super Capsule',
    type: 'first_aid',
    priority: 70,
    stages: 'baby, kid, youth, adult',
    price: 800,
    desc_jp: '飲むと病気が絶対に\n治るカプセル',
    desc_en: 'Capsule that cures diseases for sure when taken',
    stomach: 40,
    love: 40,
    sick_cure_chance: 1,
  },
  {
    id: 'fa_perfume',
    item: 'perfume',
    name_jp: '万能コロン',
    name_en: 'Magic Potion',
    type: 'first_aid',
    priority: 60,
    stages: 'baby, kid, youth, adult',
    price: 1000,
    desc_jp: '瀕死状態が治るかも\nしれないコロン',
    desc_en: 'Potion that might cure dying status',
    stomach: 20,
    love: 20,
    dying_cure_chance: 0.6,
  },
  {
    id: 'fa_superPerfume',
    item: 'superPerfume',
    name_jp: '金の万能コロン',
    name_en: 'Gold Magic Potion',
    type: 'first_aid',
    priority: 50,
    stages: 'baby, kid, youth, adult',
    price: 2000,
    desc_jp: '瀕死状態が絶対に\n治るコロン',
    desc_en: 'Potion that cures dying status for sure',
    stomach: 40,
    love: 40,
    dying_cure_chance: 1,
  },
  {
    id: 'i_vowsCoffee',
    item: 'vowsCoffee',
    name_jp: '誓いのコーヒー',
    name_en: 'Vows Coffee',
    type: 'invitation',
    priority: 100,
    stages: 'adult',
    price: 2500,
    desc_jp: 'コンビの成功を誓うコーヒー。\nコンビ結成で1人100ジェムもらえる',
    desc_en:
      'Coffee to pledge the success of the duo. Each person gets 100 gems for forming a duo.',
    reward_gems: 100,
  },
  {
    id: 'i_ultimateVowsCoffee',
    item: 'ultimateVowsCoffee',
    name_jp: '誓いのコーヒー\n極み',
    name_en: 'Ultimate Vows Coffee',
    type: 'invitation',
    priority: 90,
    stages: 'adult',
    price: 6000,
    desc_jp:
      'コンビの成功を固く誓うコーヒー。\nコンビ結成で1人300ジェムもらえる',
    desc_en:
      'Coffee to firmly pledge the success of the duo. Each person gets 300 gems for forming a duo.',
    reward_gems: 300,
  },
];
